<template>
  <div>
    <v-col cols="12" class="mx-auto">
      <div class="mx-auto">
        <v-btn
          v-if="displayBindingBarrier"
          color="primary"
          outlined
          class="text-none mr-2"
          dark
          rounded
          @click="getPossibleDoorphones"
        >
          привязать домофон
        </v-btn>
      </div>
      <v-card-text v-if="displayMain">{{ displayCardText }}</v-card-text>
      <v-card-text v-if="!displayMain">Нет привязанных домофонов.</v-card-text>
      <v-data-table
        v-if="displayMain"
        class="table"
        item-key="id"
        :items="barrierEdit.doorphones"
        :items-per-page="5"
        :headers="headersAttachedDoorphones"
        :footer-props="{
            'items-per-page-options': [5, 10],
          }"
      >
        <template v-slot:item.address="{ item }">
          <router-link class="routerLink" :to="`/doorphones/${item.id}`">
            {{ getDoorphoneAddress(item) }}
          </router-link>
        </template>
        <template v-slot:item.actions="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                tile
                small
                v-bind="attrs"
                v-on="on"
                class="btn__icon pa-0"
                width="18"
                height="18"
                @click.stop="$set(dialogRemove, item.id, true)"
              >
                <v-icon size="large">mdi-close</v-icon>
              </v-btn>
            </template>
            <span>Отвязать домофон</span>
          </v-tooltip>
          <v-dialog v-model="dialogRemove[item.id]" width="500">
            <BaseDeleteModal
              :active.sync="dialogRemove[item.id]"
              @close="$set(dialogRemove, item.id, false)"
              @submit="excisionBarrierDoorphone(item.id)"
              messageTitle="Отвязать домофон?"
              messageText="Подтверждая, вы отвяжите домофон."/>
          </v-dialog>
        </template>
      </v-data-table>
    </v-col>

    <v-dialog v-model="popupBindDoorphones" max-width="600" lazy-validation>
      <v-card class='pb-5'>
        <v-progress-linear v-if="loadingListDoorphones" indeterminate color="primary"></v-progress-linear>
        <v-card-title class="headline">
          Привязать домофон
          <v-spacer></v-spacer>
          <v-btn
            icon
            text
            x-large
            class="btn__icon pa-0"
            width="18"
            height="18"
            @click.prevent="popupBindDoorphones = false"
          >
            <v-icon size="x-large">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='serchValue'
            placeholder="Поиск по адресу"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-col class="px-5 pb-5">
          <v-text-field
            v-model='serchValueId'
            placeholder="Поиск по id"
            solo
            outlined
            dense
            hide-details
            flat
          ></v-text-field>
        </v-col>
        <v-row class="pa-4 px-5">
          <v-col>
            <v-btn
              color="green"
              outlined
              class="text-none mr-2"
              rounded
              @click.prevent="addDoorphone()"
            >
              Привязать
            </v-btn>
          </v-col>
          <v-spacer></v-spacer>
          <v-col class="text-right">
            <v-btn
              dark
              class="btn primary darken-3 white px-7 text-none"
              @click="filterDoorphones"
            >
              Поиск
            </v-btn>
          </v-col>
        </v-row>
        <v-data-table
          class="table row-click mx-5 pb-5"
          :items-per-page="10"
          :items="doorphonesArray"
          :options.sync="options"
          :server-items-length="totalDoorphones"
          :headers="headersTieDoorphones"
          item-key="id"
          show-select
          :loading="loadingListDoorphones"
          v-model="selected"
          @click:row="activateShowSelect"
          :multi-select="true"
          :footer-props="{
              'items-per-page-options': [10, 20, 50],
              showFirstLastPage: true,
            }"
        >
          <template v-slot:item.address="{ item }">
            {{ getDoorphoneAddress(item) }}
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogAddDoorphone" max-width="350">
      <v-card>
        <v-card-title class="headline">Привязать домофон?</v-card-title>
        <v-card-text>Подтверждая, вы привязываете домофон.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary darken-1"
            text
            @click.prevent="dialogAddDoorphone = false"
          >
            Отменить
          </v-btn>
          <v-btn
            color="success"
            text
            :loading="loading"
            @click.prevent="bindBarrierDoorphone()"
          >
            привязать
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import BaseDeleteModal from '@/components/BaseDeleteModal';

export default {
  name: 'BindingDoorphone',
  props: ['id'],
  components: { BaseDeleteModal },
  data: () => {
    return {
      loading: false,
      attachedDoorphones: [],
      address: '',
      popupApartmentPrefix: false,
      dialogAddDoorphone: false,
      apartmentPrefix: [],
      doorphonesArray: [],
      filters: { type: 'M' },
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
        itemsPerPage: 10,
      },
      isCreated: false,
      totalDoorphones: 0,
      selected: [],
      dialogRemove: {},
      isDisabled: true,
      popupBindDoorphones: false,
      isSelected: false,
      popupToUntieDoorphone: false,
      doorphones: [],
      selectedDoorphones: [],
      serchValue: '',
      serchValueId: '',
      doorphoneId: [],
      loadingListDoorphones: false,
      cachedListDoorphones: null,
      headersTieDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
      ],
      headersAttachedDoorphones: [
        { text: 'id', value: 'id' },
        { text: 'Адрес', value: 'address', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      include: ['mainDoorphones'],
    };
  },
  created () {
  },
  watch: {
    options: {
      handler () {
        if (!this.isCreated) {
          this.updateSort();
        } else {
          this.isCreated = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters({
      doorphone: 'Doorphone/doorphoneEditDoorphone',
      barrierEdit: 'Barriers/barrierEdit',
      roleName: 'roleName',
    }),
    displayCardText () {
      switch (this.barrierEdit.barrier.passage_type) {
        case 'B': return 'Привязанные домофоны к шлагбауму.';
        case 'G': return 'Привязанные домофоны к воротам.';
        default: return 'Привязанные домофоны.';
      }
    },
    displayMain () {
      return !!(this.barrierEdit.doorphones[0] && this.$checkPermission('remove_doorphone_barrier'));
    },
    displayBindingBarrier () {
      return this.$checkPermission('add_doorphone_barrier');
    },
  },
  methods: {
    ...mapActions({
      removeBarrierDoorphone: 'Barriers/removeBarrierDoorphone',
      addBarrierDoorphone: 'Barriers/addBarrierDoorphone',
      getDoorphones: 'Doorphone/getExpandedDoorphones',
      getBarrierInfoEdit: 'Barriers/getBarrierInfoEdit',
    }),
    activateShowSelect (value) {
      const index = this.selected.indexOf(value);

      if (index === -1) {
        this.selected.push(value);
      } else {
        this.selected.splice(index, 1);
      }
      this.isDisabled = this.selected.length === 0;
    },
    async getData () {
      await this.getBarrierInfoEdit({
        id: this.$route.params.id,
      })
        .then(() => {})
        .catch(() => {
          this.$flash_warning('Ошибка при загрузке информации');
        });
    },
    addDoorphone () {
      if (this.selected[0]) {
        this.doorphones.push(this.selected);
        this.dialogAddDoorphone = true;
      } else {
        this.$flash_danger('Выберите домофон');
      }
    },
    getDoorphoneAddress (doorphone) {
      let address = doorphone.address;
      if (doorphone.entrance > 0) {
        address = `${doorphone.address}, п.${doorphone.entrance}`;
      }
      return address;
    },
    bindBarrierDoorphone () {
      const doorphones = this.doorphones[this.doorphones.length - 1].slice();
      this.selectedDoorphones = doorphones.map(doorphone => ({
        id: doorphone.id,
        address: doorphone.address,
      }));
      const doorphoneIds = this.selectedDoorphones.map(doorphone => doorphone.id).join(',');
      const doorphoneIdsArray = doorphoneIds.split(',').map(id => id.trim());

      this.loading = true;
      this.addBarrierDoorphone({
        barrierId: this.$route.params.id,
        doorphones: doorphoneIdsArray,
      })
        .then(() => {
          this.$flash_success('Домофон успешно Привязан');
          this.getData();
        })
        .catch((err) => {
          console.error(err);
          if (err.response && err.response.status === 422) {
            const error = err.response.data.gate;
            error.forEach(item => {
              this.$flash_danger('Ошибка: ' + item);
            });
          } else {
            this.$flash_warning('Ошибка при привязки домофона');
          }
          this.selectedDoorphones = this.selectedDoorphones.filter(doorphone => this.doorphoneId.includes(doorphone.id));
        })
        .finally(() => {
          // this.loading = true;
          this.cancelBindDoorphone();
        });
    },
    excisionBarrierDoorphone (doorphoneId) {
      this.removeBarrierDoorphone({
        barrierId: this.$route.params.id,
        doorphoneId: doorphoneId,
      })
        .then(() => {
          this.$flash_success('Домофон успешно отвязан');
          this.getData();
        })
        .catch(() => {
          this.$flash_warning('Ошибка при отвязки домофона');
        })
        .finally(() => {
          this.cancelBindDoorphone();
        });
      this.loading = true;
    },
    cancelBindDoorphone () {
      this.popupBindDoorphones = false;
      this.popupApartmentPrefix = false;
      this.popupToUntieDoorphone = false;
      this.dialogAddDoorphone = false;
      this.cachedListDoorphones = null;
      this.loading = false;
      this.selected = [];
      this.selectedDoorphones = [];
      this.value = '';
      this.serchValue = '';
      this.serchValueId = '';
    },
    filterDoorphones () {
      this.options.page = 1;
      this.filters = { type: 'M' };

      if (this.isFiltersManufacturer && this.selectedDevices.length > 0) {
        this.filters.manufacturer = this.selectedDevices[0].manufacturer;
      }

      if (this.serchValue) {
        this.filters.address = this.serchValue;
      }
      if (this.serchValueId) {
        this.filters.id = this.serchValueId;
      }
      this.$router.push({
        query: {
          address: this.filters.address,
        },
      }).catch(() => {});
      this.loadDoorphones();
    },
    async getPossibleDoorphones () {
      this.filters = { type: 'M' };
      if (this.isFiltersManufacturer && this.selectedDevices.length > 0) {
        this.filters.manufacturer = this.selectedDevices[0].manufacturer;
      }
      await this.loadDoorphones();

      this.popupBindDoorphones = true;
    },
    updateSort () {
      if (this.options.sortBy.length > 0) {
        if ((this.options.sortDesc.length > 0) && (this.options.sortDesc[0])) {
          this.sort = '-' + this.options.sortBy[0];
        } else {
          this.sort = this.options.sortBy[0];
        }
      } else {
        this.sort = '';
      }
      this.loadDoorphones();
    },
    async loadDoorphones () {
      await this.getDoorphones({
        pagination: 1,
        page: this.options.page,
        limit: this.options.itemsPerPage,
        sort: this.sort,
        filters: this.filters,
        include: this.include,
      })
        .then((data) => {
          this.loading = false;
          this.totalDoorphones = data.meta.total;
          this.doorphonesArray = data.doorphones
            .map((doorphone) => {
              doorphone.apartmentPrefix = doorphone.address.split(', д.').pop().replace(/\D+/g, '');
              return doorphone;
            })
            .filter((doorphone) => {
              const isNotSelected = !this.selectedDoorphones.some(selected => selected.id === doorphone.id);
              const hasDeviceId = this.isFiltersManufacturer ? !!doorphone.device_id : true;
              return isNotSelected && hasDeviceId;
            });
        })
        .catch((err) => {
          console.error(err);
          this.$flash_warning('Ошибка при загрузке домофонов');
        })
        .finally(() => {
          this.loadingListDoorphones = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.routerLink {
  text-decoration: none;
}

.v-application a {
  color: #434850;
}

.row-click {
  cursor: pointer;
}

a:hover.routerLink {
  text-decoration: underline;
}
</style>
